<template>
  <div>
    <MainHeader />
    <MainForm :isBigClockVisible="isBigClockVisible" />
    <Footer />
    <!-- Products modal -->
    <div class="popup" id="product-popup">
      <div class="popup__content">
        <a href="#section_form" class="popup__content__close">&times;</a>
        <Accordion />
      </div>
    </div>
    <!--Table modal-->
    <div class="popup" id="table-popup">
      <div class="popup__content">
        <a href="#section_form" class="popup__content__close">&times;</a>
        <div class="table-wrapper">
          <div class="table-wrapper__header">
            <h1>Please check the data once more before submiting</h1>
          </div>
          <div class="table-wrapper__alert-info">
            <Table
              :table-data="this.$store.getters.getAlertInfo"
              table-header="Alert Info"
            />
          </div>
          <div class="table-wrapper__event-info">
            <Table
              :table-data="this.$store.getters.getEventInfo"
              table-header="Event Info"
            />
          </div>
          <div class="table-wrapper__event-description">
            <ReadOnlyTextArea
              :table-data="this.$store.getters.getDescription"
              table-header="Description"
            />
          </div>
          <div class="table-wrapper__instruction">
            <ReadOnlyTextArea
              :table-data="this.$store.getters.getInstruction"
              table-header="Instruction"
            />
          </div>
        </div>
        <div class="popup__content--table__button">
          <Button
            buttonText="Submit form"
            buttonSize="sm"
            animated="false"
            green="true"
            action="#confirmation-box-popup"
          />
        </div>
      </div>
    </div>
    <!--Google Maps modal -->
    <div class="popup" id="google-maps-popup">
      <div class="popup__content">
        <div class="popup__close-button--google">
          <CloseButton />
        </div>
        <GmapMap
          :center="centerPoint"
          :zoom="5"
          style="width: 100%; height: 100%; padding-top: 2rem"
        />
      </div>
    </div>
    <!--Confirmation box modal -->
    <div class="popup" id="confirmation-box-popup">
      <div class="popup__content--confirmation">
        <div class="popup__content--confirmation__wrapper">
          <div class="popup__content--confirmation__wrapper__warning">
            <img src="assets/image/svg/warning.svg" />
          </div>
          <div class="popup__content--confirmation__wrapper__header">
            <h1><b>Are you sure you wish to continue?</b></h1>
            <br />
          </div>
          <div class="popup__content--confirmation__wrapper__text">
            <p>
              Once you click on "Submit" data will be pushed to the server and
              application will reload to landing page. If you want to recheck
              your data once again click "Cancel".
            </p>
          </div>
          <div class="popup__content--confirmation__wrapper__buttons">
            <Button
              buttonText="Submit"
              buttonSize="sm"
              animated="false"
              green="true"
              @click.native="submitForm"
            />
            &nbsp;&nbsp;
            <Button
              buttonText="Cancel"
              buttonSize="sm"
              animated="false"
              green="true"
              action="#section-form"
            />
          </div>
        </div>
      </div>
    </div>
    <!--Rating modal -->
    <div class="popup" id="rating-box-popup">
      <div class="popup__content--rating">
        <div class="popup__content--rating__wrapper">
          <div class="popup__content--rating__wrapper__header">
            <h1>Your alert was successfully submited!</h1>
          </div>
          <div class="popup__content--rating__wrapper__success">
            <img src="assets/image/svg/success.svg" />
          </div>
          <div class="popup__content--rating__wrapper__text">
            <p>Thank you for using FFGS Simulator!</p>
            <p>
              Please spare some time and share your valuable feedback with us so
              we keep on improving.
            </p>
          </div>
          <div class="popup__content--rating__wrapper__rating">
            <StarRating />
          </div>
          <div class="popup__content--rating__wrapper__textbox">
            <textarea
              placeholder=" Your feedback!"
              @input="storeFeedback"
            ></textarea>
          </div>
          <div class="popup__content--rating__wrapper__button">
            <Button
              buttonText="Submit"
              buttonSize="sm"
              animated="false"
              green="true"
              @click.native="submitRating"
              action="#redirect-box-popup"
            />
          </div>
        </div>
      </div>
    </div>
    <!--Redirect modal -->
    <div class="popup" id="redirect-box-popup">
      <div class="popup__content--redirect">
        <div class="popup__content--redirect__wrapper">
          <div class="popup__content--redirect__wrapper__text">
            <p style="color: white">Thank you for using FFGS Simulator!</p>
          </div>
          <div class="popup__content--redirect__wrapper__icon">
            <img src="assets/image/svg/smile-icon.webp" />
          </div>
          <div class="popup__content--redirect__wrapper__button">
            <Button
              buttonText="Exit"
              buttonSize="sm"
              animated="false"
              green="true"
              action="https://ffgs-simulator-v2.web.app/"
            />
          </div>
        </div>
      </div>
    </div>
    <!--    Error modal -->
    <div class="popup" id="error-box-popup">
      <div class="popup__content--error">
        <div class="popup__content--error__wrapper">
          <div class="popup__content--error__wrapper__warning">
            <img src="assets/image/svg/error.svg" />
          </div>
          <div class="popup__content--error__wrapper__text">
            <h1>Error...</h1>
            <p>
              There seems to be a problem communicating with the server. Please
              check your internet connection.
            </p>
            <p>If the issue persists kindly contact development team.</p>
          </div>
          <div class="popup__content--error__wrapper__button">
            <Button
              buttonText="Try Again"
              buttonSize="sm"
              animated="false"
              green="true"
              action="#submit-form"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "./MainHeader.vue";
import MainForm from "./MainForm.vue";
import Footer from "../UI/Footer.vue";
import CloseButton from "../UI/CloseButton.vue";
import Table from "@/components/UI/Table";
import Button from "@/components/UI/Button";
import ReadOnlyTextArea from "@/components/UI/ReadOnlyTextArea";
import StarRating from "@/components/UI/StarRating";
import Accordion from "@/components/UI/Accordion";
import { getStorage, ref, uploadBytesResumable } from "firebase/storage";

export default {
  components: {
    MainHeader,
    MainForm,
    Footer,
    CloseButton,
    Button,
    Table,
    ReadOnlyTextArea,
    StarRating,
    Accordion,
  },
  data() {
    return {
      isBigClockVisible: true,
      centerPoint: {
        lat: 0,
        lng: 0,
      },
      redirect: "",
    };
  },
  methods: {
    isInViewport() {
      var element = document.querySelector(".mouse-scroll");
      var rect = element.getBoundingClientRect();

      var isInView =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      if (isInView) {
        this.isBigClockVisible = true;
      } else {
        this.isBigClockVisible = false;
      }
    },
    submitForm() {
      console.log("Submit");
      let file = null;
      let form = this.$store.getters.getAllFormValues;
      let sender = this.$store.getters.getAlertInfo.sender;
      let uniqueSenderWithTime = sender + "_" + Date.now().toString();

      file = new File(
        [
          JSON.stringify(form, null, 2)
            .replaceAll('"', "")
            .replaceAll("{", "")
            .replaceAll("}", ""),
        ],
        uniqueSenderWithTime,
        { type: "application/octet-stream" }
      );

      this.storeOnFirebaseStorage(
        file,
        "https://ffgs-simulator-v2.web.app/ffgs-simulator#rating-box-popup"
        //"http://localhost:8080/ffgs-simulator#rating-box-popup"
      );
    },
    submitRating() {
      console.log("Rating");
      let file = null;
      let feedback = this.$store.getters.getFeedbackValue;
      let sender = this.$store.getters.getAlertInfo.sender + "_rating";
      let starRating = this.$store.getters.getStarRating;

      let text =
        "Person " +
        sender +
        " has rated the experience with " +
        starRating +
        " stars. Additional feedback shared is: " +
        feedback;

      file = new File(
        [JSON.stringify(text, null, 2)],
        sender + "_" + Date.now().toString(),
        { type: "text/plain" }
      );
      this.storeOnFirebaseStorage(
        file,
        "https://ffgs-simulator-v2.web.app/ffgs-simulator#redirect-box-popup"
        //"http://localhost:8080/ffgs-simulator#redirect-box-popup"
      );
    },
    storeOnFirebaseStorage(file, successRedirect) {
      const storage = getStorage();
      const storageRef = ref(storage, file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      console.log("Uploading " + file);
      uploadTask.on(
        "state_changed",
        () => {},
        (error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          console.log("error " + error);
          location.href =
            "https://ffgs-simulator-v2.web.app/ffgs-simulator#error-box-popup";
          //"http://localhost:8080/ffgs-simulator#error-box-popup"
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          console.log("Success");
          location.href = successRedirect;
        }
      );
    },
    storeFeedback(e) {
      this.$store.commit("updateFeedback", e.target.value);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.isInViewport);

    const coordinates = this.$store.getters.getSelectedRegion.regionCoordinates;
    const lat = parseFloat(coordinates.lat);
    const lng = parseFloat(coordinates.lng);
    this.centerPoint.lat = lat;
    this.centerPoint.lng = lng;
  },
  destroyed() {
    window.removeEventListener("scroll", this.isInViewport);
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
@import "../../sass/_mixins.scss";

.popup {
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba($color-black, 0.8);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s;

  &:target {
    opacity: 1;
    visibility: visible;
  }

  &:target &__close-button {
    visibility: visible;
    transform: scale(1);
  }

  &:target &__close-button:hover {
    transform: scale(1.2);
  }

  &:target &__content {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &:target &__content--confirmation {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &:target &__content {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &:target &__content--rating {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &:target &__content--redirect {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &:target &__content--error {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &__close {
    &:link,
    &:visited {
      color: $color-grey-dark;
      position: absolute;
      top: 1.5rem;
      right: 2.5rem;
      font-size: 3rem;
      text-decoration: none;
      display: inline-block;
      transition: all 0.2s;
      line-height: 1;
      z-index: 100;
    }

    &:hover {
      color: $color-primary;
    }
  }

  &__close-button {
    position: absolute;
    top: 95%;
    right: 50%;
    transform: scale(0.5);
    transition: all 0.7s 0.2s;

    &--google {
      position: absolute;
      top: -3%;
      right: -6%;
      transform: scale(0.5);
      transition: all 0.7s 0.2s;
    }
  }

  //CONTENT MODAL
  &__content {
    //@include absCenter;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 45%;
    height: 85%;
    background-image: linear-gradient(
      to right bottom,
      $color-primary-light,
      $color-primary-dark
    );
    background-color: $color-white;
    box-shadow: 0 0 5rem -0.5rem rgba(white, 0.8);
    border-radius: 1rem;
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
    transition: all 0.7s 0.2s;
    z-index: 101;

    &__close {
      &:link,
      &:visited {
        color: $color-white;
        position: absolute;
        top: 1.5rem;
        right: 2.5rem;
        font-size: 3rem;
        text-decoration: none;
        display: inline-block;
        transition: all 0.2s;
        line-height: 1;
        z-index: 10;
      }

      &:hover {
        color: $color-tertiary;
      }
    }

    &--table__button {
      position: absolute;
      top: 89%;
      left: 83%;
    }

    //CONFIRMATION MODAL
    &--confirmation {
      @include absCenter;
      width: 25%;
      height: 37%;
      background-image: linear-gradient(
        to right bottom,
        $color-primary-light,
        $color-primary-dark
      );
      background-color: $color-white;
      box-shadow: 0 0 5rem -0.5rem rgba(white, 0.8);
      border-radius: 1rem;
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.5);
      transition: all 0.7s 0.2s;
      z-index: 101;

      &__wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;

        &__warning {
          height: 20%;
          width: 100%;
          margin-bottom: 3rem;
          margin-top: 3rem;

          img {
            margin-left: 25%;
            height: 100%;
            width: 50%;
          }
        }

        &__header {
          height: 10%;
          width: 100%;
          margin-bottom: 2rem;
          text-align: center;
          color: $color-white;
        }

        &__text {
          height: 30%;
          width: 70%;
          text-align: center;
          color: $color_white;
          font-size: 1.3rem;
          margin-bottom: 3rem;
        }

        &__buttons {
          height: 30%;
          margin-bottom: 2rem;
        }
      }
    }

    //RATING MODAL
    &--rating {
      @include absCenter;
      width: 35%;
      height: 70%;
      background-image: linear-gradient(
        to right bottom,
        $color-primary-light,
        $color-primary-dark
      );
      background-color: $color-white;
      box-shadow: 0 0 5rem -0.5rem rgba(white, 0.8);
      border-radius: 1rem;
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.5);
      transition: all 0.7s 0.2s;
      z-index: 101;

      &__wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;

        &__header {
          color: $color-white;
          text-align: center;
          margin-bottom: 2rem;
          border-bottom: 1px solid $color-white;
        }

        &__success {
          width: 100%;
          height: 25%;
          text-align: center;
          margin-bottom: 2rem;

          img {
            height: 100%;
          }
        }

        &__text {
          color: $color-white;
          width: 70%;
          margin-bottom: 2rem;
          font-size: 1.2rem;
          text-align: center;
        }

        &__rating {
          margin-bottom: 2rem;
        }

        &__textbox {
          margin-bottom: 4rem;
          width: 50%;
          height: 25%;

          textarea {
            resize: none;
            height: 100%;
            width: 100%;
            border-radius: 1rem;
          }
        }
      }
    }

    //REDIRECT MODAL
    &--redirect {
      @include absCenter;
      width: 25%;
      height: 30%;
      background-image: linear-gradient(
        to right bottom,
        $color-primary-light,
        $color-primary-dark
      );
      background-color: $color-white;
      box-shadow: 0 0 5rem -0.5rem rgba(white, 0.8);
      border-radius: 1rem;
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.5);
      transition: all 0.7s 0.2s;
      z-index: 101;

      &__wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;

        &__text {
          margin-top: 5rem;
          font-size: 2rem;
          border-bottom: solid 1px $color-white;
        }

        &__button {
          margin-top: 4rem;
          margin-bottom: 3rem;
        }

        &__icon {
          width: 20%;
          margin-top: 2rem;

          img {
            width: 100%;
          }
        }
      }
    }

    //ERROR MODAL
    &--error {
      @include absCenter;
      width: 25%;
      height: 30%;
      background-image: linear-gradient(
        to right bottom,
        $color-primary-light,
        $color-primary-dark
      );
      background-color: $color-white;
      box-shadow: 0 0 5rem -0.5rem rgba(white, 0.8);
      border-radius: 1rem;
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.5);
      transition: all 0.7s 0.2s;
      z-index: 101;

      &__wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;

        &__warning {
          width: 100%;
          height: 25%;
          text-align: center;
          margin-bottom: 2rem;

          img {
            height: 100%;
          }
        }

        &__text {
          h1 {
            color: white;
            text-align: center;
            margin-bottom: 2rem;
          }
          p {
            color: white;
            text-align: center;
            margin-bottom: 2rem;
            font-size: 1.2rem;
          }
        }

        &__button {
          margin-top: 3rem;
        }
      }
    }
  }
}

//Table
.table-wrapper {
  @include absCenter;
  display: flex;
  //justify-content: space-between;
  flex-flow: row wrap;
  width: 70%;
  height: 90%;

  &__header {
    width: 100%;
    color: $color-white;
    text-align: center;
    margin-bottom: 3rem;
    border-bottom: 1px solid;
  }

  &__alert-info {
    height: 45%;
    width: 45%;
    background: lightgray;
    margin-right: 1rem;
    font-size: 1.2rem;
    border-radius: 1rem;
  }

  &__event-info {
    height: 45%;
    width: 45%;
    background: lightgray;
    font-size: 1.2rem;
    border-radius: 1rem;
  }

  &__event-description {
    height: 45%;
    width: 45%;
    background: lightgray;
    margin-right: 1rem;
    margin-top: 1rem;
    font-size: 1.2rem;
    overflow: scroll;
    border-radius: 1rem;
    overscroll-behavior: none;
  }

  &__event-description::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }

  &__instruction {
    height: 45%;
    width: 45%;
    background: lightgray;
    margin-top: 1rem;
    font-size: 1.2rem;
    overflow: scroll;
    border-radius: 1rem;
    overscroll-behavior: none;
  }

  &__instruction::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
}
</style>
